import React  from 'react';
import TwoButtons from './components/buttonsContainer/buttons.component';
import Header from './components/header/header.component';

import './App.css';

function App(props){
 return(
   <div>
     <Header/>
     <div><TwoButtons/></div>

   </div>
  
 )

}

export default App;
